import { LitElement, css, html } from "lit";
//#region src/pd-collapse-group/PdCollapseGroup.ts
/**
* Groups multiple pd-collapse elements to ensure only one is open at a time.
*
* @tagname pd-collapse-group
*
* @slot - List of pd-collapse elements.
*
* @csspart container - The group container element.
*
* @cssprop --pd-collapse-group-gap - Gap between collapse elements. Default: `0.5rem`.
*/
var PdCollapseGroup = class extends LitElement {
	constructor(..._args) {
		super(..._args);
		this._assignedCollapses = /* @__PURE__ */ new Map();
		this._onRegister = (e) => {
			const { name, collapse } = e.detail;
			console.debug("###### _onRegister collapse", name);
			this._assignedCollapses.set(name, collapse);
			e.stopPropagation();
		};
		this._onUnRegister = (e) => {
			const { name } = e.detail;
			console.debug("###### _onUnRegister collapse", name);
			this._assignedCollapses.delete(name);
			e.stopPropagation();
		};
	}
	static {
		this.styles = [css`
      :host {
        display: block;
      }
      .container {
        display: flex;
        flex-direction: column;
        gap: var(--pd-collapse-group-gap, var(--pd-spacing-md));
      }
    `];
	}
	connectedCallback() {
		super.connectedCallback();
		this.addEventListener("pd-collapse-register", this._onRegister);
		this.addEventListener("pd-collapse-toggle", this._onToggle);
		document.addEventListener("pd-collapse-unregister", this._onUnRegister);
	}
	disconnectedCallback() {
		super.disconnectedCallback();
		this.removeEventListener("pd-collapse-register", this._onRegister);
		this.removeEventListener("pd-collapse-toggle", this._onToggle);
		document.removeEventListener("pd-collapse-unregister", this._onUnRegister);
	}
	render() {
		return html`
      <div class="container" part="container">
        <slot></slot>
      </div>
    `;
	}
	_onToggle(e) {
		if (e.detail.active === true) this._deactivateOtherCollapses(e.detail.name);
		e.stopPropagation();
	}
	_deactivateOtherCollapses(targetKey) {
		this._assignedCollapses.forEach((collapse, key) => {
			if (key !== targetKey) collapse.active = false;
		});
	}
};
//#endregion
export { PdCollapseGroup };
